import { create } from 'zustand'
// Plan 27 — switched to vendor-neutral User/Session types from @/lib/auth.
// Was: import type { Session, User } from '@supabase/supabase-js'
import type { Session, User } from '@/lib/auth'

interface AuthState {
  user: User | null
  session: Session | null
  loading: boolean
  adminLoading: boolean
  isPlatformAdmin: boolean
  isOrgAdmin: boolean
  setAuth: (user: User | null, session: Session | null) => void
  setPlatformAdmin: (isPlatformAdmin: boolean) => void
  setOrgAdmin: (isOrgAdmin: boolean) => void
  setAdminLoading: (adminLoading: boolean) => void
  setLoading: (loading: boolean) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  session: null,
  loading: true,
  adminLoading: true,
  isPlatformAdmin: false,
  isOrgAdmin: false,
  setAuth: (user, session) => set({ user, session, loading: false }),
  setPlatformAdmin: (isPlatformAdmin) => set({ isPlatformAdmin, adminLoading: false }),
  setOrgAdmin: (isOrgAdmin) => set({ isOrgAdmin }),
  setAdminLoading: (adminLoading) => set({ adminLoading }),
  setLoading: (loading) => set({ loading }),
  logout: () => set({ user: null, session: null, isPlatformAdmin: false, isOrgAdmin: false, adminLoading: false }),
}))
